import { DispositifSummaryDto, DispositifDetailDto, DispositifActivityResponseDto } from '../dtos/dispositif/dispositif.response.dto';
import { DispositifRequestDto } from '../dtos/dispositif/dispositif.request.dto';
import { Dispositif, DispositifActivity, DispositifCreateData } from '@domain/dispositif/dispositif';

export class DispositifMapper {
  static fromSummaryDto(dto: DispositifSummaryDto): Dispositif {
    return new Dispositif(dto.id, dto.name, dto.startDate, dto.active, dto.endDate);
  }

  static fromDetailDto(dto: DispositifDetailDto): Dispositif {
    const activities = (dto.authorizedActivities ?? []).map(
      (a: DispositifActivityResponseDto) => new DispositifActivity(a.id, a.name, a.active, a.description)
    );
    return new Dispositif(dto.id, dto.name, dto.startDate, dto.active, dto.endDate, dto.description, dto.allActivities,
      activities, dto.participantIds ?? []);
  }

  static toRequestDto(data: DispositifCreateData): DispositifRequestDto {
    return {
      name: data.name,
      description: data.description,
      startDate: data.startDate,
      endDate: data.endDate,
      active: data.active,
      allActivities: data.allActivities,
      authorizedActivityIds: data.authorizedActivityIds,
      participantIds: data.participantIds,
    };
  }
}
